import React, { Fragment } from 'react'
import currency from 'currency.js'
import { Element as ScrollElement } from 'react-scroll'
import Favorite from '../community/Favorite'

export const MenuListItem = ({
  item: { id, name, price, description },
  availableFavorites,
  onSelectMenuItem,
  addFavoriteStart,
  deleteFavoriteStart,
  favorites
}) => (
  <Fragment>
    <li className="placeorder-item">
      {favorites && favorites.length >= 1 ? (
        <Favorite
          id={id}
          deleteFavoriteStart={deleteFavoriteStart}
          classNames={{ 'placeorder-item_favorite': true }}
        />
      ) : availableFavorites && availableFavorites.length > 0 ? (
        <Favorite
          id={id}
          addFavoriteStart={addFavoriteStart}
          classNames={{ 'placeorder-item_favorite': true }}
        />
      ) : null}
      <button
        className="link"
        onClick={evt => {
          evt.preventDefault()
          onSelectMenuItem(id)
        }}
      >
        <div className="row">
          <div className="col-xs-10 placeorder-item_title">{name}</div>
          <div className="col-xs-2 end-xs placeorder-item_price">
            {currency(price).format()}
          </div>
        </div>
        <div className="col-xs-12 placeorder-item_description">
          {description}
        </div>
      </button>
    </li>
  </Fragment>
)

MenuListItem.defaultProps = {
  item: {}
}

export const MenuList = ({
  items,
  onSelectMenuItem,
  availableFavorites,
  addFavoriteStart,
  favorites,
  deleteFavoriteStart
}) => (
  <ul className="placeorder-list">
    {items.map(item => (
      <MenuListItem
        availableFavorites={
          availableFavorites &&
          availableFavorites.filter(favorite => favorite.menuItemId === item.id)
        }
        addFavoriteStart={addFavoriteStart}
        deleteFavoriteStart={deleteFavoriteStart}
        favorites={
          favorites &&
          favorites.filter(favorite => favorite.menuItemId === item.id)
        }
        key={item.id}
        item={item}
        onSelectMenuItem={onSelectMenuItem}
      />
    ))}
  </ul>
)

MenuList.defaultProps = {
  items: []
}

export const MenuSection = ({
  section: { id, name, description, menuItems },
  availableFavorites,
  onSelectMenuItem,
  addFavoriteStart,
  deleteFavoriteStart,
  favorites
}) => (
  <ScrollElement name={`${id}`}>
    <section id={`menu-section-${id}`}>
      <h2 className="placeorder-header">{name}</h2>
      <p className="placeorder-description">{description}</p>
      <MenuList
        addFavoriteStart={addFavoriteStart}
        deleteFavoriteStart={deleteFavoriteStart}
        availableFavorites={availableFavorites}
        items={menuItems}
        favorites={favorites}
        onSelectMenuItem={onSelectMenuItem}
      />
    </section>
  </ScrollElement>
)

MenuSection.defaultProps = {
  section: {}
}

export const Menu = ({
  menuData,
  onSelectMenuItem,
  availableFavorites,
  addFavoriteStart,
  favorites,
  deleteFavoriteStart
}) => (
  <section className="placeorder">
    <div className="placeorder-menu">
      {menuData.subMenus.map(submenu => (
        <MenuSection
          availableFavorites={availableFavorites}
          deleteFavoriteStart={deleteFavoriteStart}
          favorites={favorites}
          addFavoriteStart={addFavoriteStart}
          key={submenu.id}
          section={submenu}
          onSelectMenuItem={onSelectMenuItem}
        />
      ))}
    </div>
  </section>
)

Menu.defaultProps = {
  menuData: {
    subMenus: []
  }
}

export default Menu
